import React from "react"
import {toAbsoluteUrl} from "../../../../../../_metronic/_helpers";

const Tab3 = ({tab, setTab, themeData, isSubmitting, includeImageFields = true}) => {
    return <div className="form mt-0 mt-lg-10" id="kt_form">
        <div
            className="pb-5"
            data-wizard-type="step-content"
            data-wizard-state={tab === 3 ? "current" : ""}
        >
            {/* <!--begin::Section--> */}
            <h4 className="mb-10 font-weight-bold text-dark">Review Theme Details and Submit</h4>
            <h6 className="font-weight-bolder mb-3">Basic Details:</h6>
            <div className="text-dark-50 line-height-lg">
                {/* <!--end::Input--> */}
                <div className="row">
                    <div className="col-xl-6">
                        Name: <h6 className="d-inline px-3">{themeData?.name}</h6>
                    </div>
                    <div className="col-xl-6">
                        Description: <h6 className="d-inline px-3">{themeData?.description}</h6>
                    </div>
                </div>
                {/* <!--end::Input--> */}
                {includeImageFields
                && <div className="row">
                    <div className="col-xl-6">
                        Banner URL: <h6 className="d-inline px-3">{themeData?.banner?.name}</h6>
                    </div>
                    <div className="col-xl-6">
                        Icon URL: <h6 className="d-inline px-3">{themeData?.logo?.name}</h6>
                    </div>
                </div>
                }
                {/* <!--end::Input--> */}
                <div className="row">
                    <div className="col-xl-6">
                        Status: <h6 className="d-inline px-3">{themeData?.status}</h6>
                    </div>
                </div>
                {/* <!--end::Input--> */}
            </div>
            <div className="separator separator-dashed my-5"/>
            {/* <!--end::Section--> */}

            <h6 className="font-weight-bolder mb-3">Assets</h6>
            <div className="text-dark-50 line-height-lg">
                {Object.values(themeData?.assets || {})?.map((instrument) => (
                    <div className="mb-3" key={instrument.id || instrument.instrumentId}>
                        <div className="menu-item d-flex align-items-center">
                            <img
                                className="mx-3"
                                alt={instrument.symbol && instrument.symbol[0]}
                                src={instrument.imageUrl && instrument.imageUrl}
                                width="36px"
                                onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg")
                                }}
                            />
                            <span className="menu-text">
                                {instrument.symbol && instrument.symbol.substr(0, 20)}
                                <br/>
                                {instrument.name && instrument.name.substr(0, 20)}
                            </span>
                        </div>
                    </div>
                ))
                }
            </div>
            {/* <!--end::Section--> */}

            {/* <!--begin: Wizard Actions--> */}
            <div className="d-flex justify-content-between border-top mt-5 pt-10">
                <div className="mr-2">
                    <button
                        onClick={_ => setTab(2)}
                        type="button"
                        className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4"
                    >
                        Previous
                    </button>
                </div>
                <div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                    >

                        {
                            isSubmitting ?
                                <div className="spinner-border spinner-border-sm mx-5 text-white" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                :
                                "Submit"
                        }
                    </button>
                </div>
            </div>
            {/* <!--end: Wizard Actions--> */}
        </div>
    </div>
}

export default Tab3;